export const FETCH_REQUEST = 'FETCH_REQUEST';
export const FETCH_ADVERTISER_LIST = 'FETCH_ADVERTISER_LIST';
export const FETCH_CAMPAIGN_LIST = 'FETCH_CAMPAIGN_LIST';
export const FETCH_ERROR = 'FETCH_ERROR';
export const FETCH_SUCCESS = 'FETCH_SUCCESS';
export const SET_ADVERTISER = 'SET_ADVERTISER';
export const FETCH_CAMPAIGN_LIST_BY_ADVERTISER = 'FETCH_CAMPAIGN_LIST_BY_ADVERTISER';
export const SET_CAMPAIGN_LIST_FOR_REPORTING = 'SET_CAMPAIGN_LIST_FOR_REPORTING';
export const SET_CAMPIGN_LIST_SELECTED = 'SET_CAMPIGN_LIST_SELECTED';
export const FETCH_ADVERTISER_REQUEST = 'FETCH_ADVERTISER_REQUEST';
export const FETCH_CAMPAIGN_ERROR = 'FETCH_CAMPAIGN_ERROR';
export const FETCH_ADVERTISER_ERROR = 'FETCH_ADVERTISER_ERROR';
export const FETCH_ANDROID_CAMPAIGN_COUNT = 'FETCH_ANDROID_CAMPAIGN_COUNT';
export const FETCH_IOS_CAMPAIGN_COUNT = 'FETCH_IOS_CAMPAIGN_COUNT';
export const RESET_CAMPAIGN_COUNT = 'RESET_CAMPAIGN_COUNT';
export const FETCH_ORG_LIST = 'FETCH_ORG_LIST';
export const SET_ADVERTISER_FILTERED_DATA = 'SET_ADVERTISER_FILTERED_DATA';
export const FETCHED_USER_ROLE = 'FETCHED_USER_ROLE';
export const FETCH_ALL_DASHBOARD_USER_LIST = 'FETCH_ALL_DASHBOARD_USER_LIST';

// Mailer-specific campaign types
export const FETCH_MAILER_SKAN_CAMPAIGNS_REQUEST = 'FETCH_MAILER_SKAN_CAMPAIGNS_REQUEST';
export const FETCH_MAILER_SKAN_CAMPAIGNS_SUCCESS = 'FETCH_MAILER_SKAN_CAMPAIGNS_SUCCESS';
export const FETCH_MAILER_SKAN_CAMPAIGNS_FAILURE = 'FETCH_MAILER_SKAN_CAMPAIGNS_FAILURE';

export const FETCH_MAILER_REGULAR_CAMPAIGNS_REQUEST = 'FETCH_MAILER_REGULAR_CAMPAIGNS_REQUEST';
export const FETCH_MAILER_REGULAR_CAMPAIGNS_SUCCESS = 'FETCH_MAILER_REGULAR_CAMPAIGNS_SUCCESS';
export const FETCH_MAILER_REGULAR_CAMPAIGNS_FAILURE = 'FETCH_MAILER_REGULAR_CAMPAIGNS_FAILURE';

export const CLEAR_MAILER_CAMPAIGNS = 'CLEAR_MAILER_CAMPAIGNS';

export const FETCH_CAMPAIGNS_FOR_QUARTERS_LOADING = 'FETCH_CAMPAIGNS_FOR_QUARTERS_LOADING';
export const FETCH_CAMPAIGNS_FOR_QUARTERS_DONE = 'FETCH_CAMPAIGNS_FOR_QUARTERS_DONE';

export const CLEAR_CAMPAIGN_LIST = 'CLEAR_CAMPAIGN_LIST';

export const SET_WOW_CAMPAIGN_LOADING = 'SET_WOW_CAMPAIGN_LOADING';
